import { render, staticRenderFns } from "./uni-popup.vue?vue&type=template&id=728667af&"
import script from "./uni-popup.vue?vue&type=script&lang=js&"
export * from "./uni-popup.vue?vue&type=script&lang=js&"
import style0 from "./uni-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728667af')) {
      api.createRecord('728667af', component.options)
    } else {
      api.reload('728667af', component.options)
    }
    module.hot.accept("./uni-popup.vue?vue&type=template&id=728667af&", function () {
      api.rerender('728667af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uni-popup/uni-popup.vue"
export default component.exports